import React, { memo } from 'react';
import { FormSelect, FormSelectItem } from '@core/components/form';
import { CategoryImageSettings } from './CategoryImageSettings';
import { CategoryId } from '@business/entities/category';
import { ItemConsiderationCategoryItemForm, ItemConsiderationCategoryImageFormData } from '../ItemConsiderationBlock';

interface CategoryAccordionContentProps {
  categoryCtrl: ItemConsiderationCategoryItemForm;
  categoryIndex: number;
  categoryItems: FormSelectItem<any, any>[];
  categoryId: CategoryId;
  imageData: ItemConsiderationCategoryImageFormData;
  updateCategoryImage: (categoryId: CategoryId, imageData: Partial<ItemConsiderationCategoryImageFormData>) => void;
}

export const CategoryAccordionContent = memo((props: CategoryAccordionContentProps) => {
  const { categoryCtrl, categoryIndex, categoryItems, categoryId, imageData, updateCategoryImage } = props;

  return (
    <div className="p-3">
      <div className="mb-3">
        <FormSelect control={categoryCtrl.controls.categoryId} items={categoryItems} label={`Category ${categoryIndex + 1}`} />
      </div>

      <CategoryImageSettings
        categoryId={categoryId}
        categoryImageData={imageData}
        updateCategoryImage={updateCategoryImage}
        categoryIndex={categoryIndex}
      />
    </div>
  );
});
